import React from 'react'
import Layout from '../../../components/corporateAdmin/Layout'
import { Helmet } from 'react-helmet'
import Chart from '../../../components/ui/demo/Chart'

function Meals() {
  return (
    <div>
            <Layout>
                <Helmet>
                    <title>Admin - Meals</title>
                </Helmet>
                <Chart title="Total meals served"/>

            </Layout>
        </div>
  )
}

export default Meals
